<template>
  <div class="quota-table">
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"  border height="200">
      <el-table-column
        v-for="item in config.formUp"
        :prop="item.prop"
        :label="item.label"
        :key="item.prop"
        :show-overflow-tooltip="true"
      ></el-table-column>
        <el-table-column :label="$translate('lang.E3202101250010', { defaultText: '状态' })">
        <template slot-scope="scope">
          <span :style="{color:scope.row.state===0?'':'red'}">
            {{scope.row.state===0?$translate('lang.E3202102260004', { defaultText: '启用' }):$translate('lang.E3202102260003', { defaultText: '停用' })}}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$translate('lang.E3202102230005', { defaultText: '操作' })">
        <template slot-scope="scope">
          <el-button type="text" class="operating-button"  @click="deleteToday(scope.row)">
            {{scope.row.state==0?$translate('lang.E3202102260003', { defaultText: '停用' }):$translate('lang.E3202102260004', { defaultText: '启用' })}}
          </el-button>
          <el-button type="text" @click="redact(scope.row)">{{$translate('lang.E3202102260009', { defaultText: '编辑' })}}</el-button>
          <el-button type="text" @click="deleteRow(scope.row)">{{$translate('lang.E3202102230004', { defaultText: '删除' })}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import config from './quotaConfig.js';
export default {
    props: ['tableData'],
    data() {
        return {
            config: config,
            tableList: null
        };
    },

    methods: {
        redact(row) {
            this.$emit('changePush', row);
        },
        deleteRow(row) {
            this.$emit('deleteRow', row);
        },
        deleteToday(row) {
            this.$confirm(this.$translate('lang.E3202103100015', { defaultText: '是否确认此操作?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    if (row.state === 1) {
                        row.state = 0;
                        this.$emit('stateChange', row);
                    } else {
                        row.state = 1;
                        this.$emit('stateChange', row);
                    }
                })
                .catch(() => {
                });
        }
    }
};
</script>
<style lang="less">
.quota-table{
  .el-table--border {
        border: 1px solid #EBEEF5;
    }
}
</style>